<div *ngIf="step && !isLoading()" class="user-to-groups">
  <div class="group">Select groups</div>
  <div class="group-list add_user">
    <div class="group-list-item">
      <!-- <md-checkbox ng-checked="step.isAllSelected('groupIds')" aria-label="group selection"></md-checkbox> -->
      <mat-checkbox
        color="primary"
        class="selectedcheckBox"
        [checked]="selectedAll.isChecked"
        aria-label="group selection"
        (click)="flipValues();clickDetected($event);"
      ></mat-checkbox>
      <div class="selectAll">Select all</div>
    </div>
    <!-- [captureOutput]="step._returnOutput('groupIds', step.dataSource, null, { isChecked: true })" -->
    <div
      class="group-list-item"
      *ngFor="let group of step.dataSource let isOdd = odd"
      [attr.disabled]="group.disabled"
      [ngClass]="[isOdd ? 'stripped' : '', group.disabled ? 'disabledListItem'  : '']"
    >
      <ng-container *ngIf="!group.hidden">
        <!-- <md-checkbox ng-checked="group.isChecked" aria-label="group selection"></md-checkbox> -->
        <mat-checkbox
          color="primary"
          [disabled]="group.disabled"
          [checked]="group.isChecked"
          class="selectedcheckBox"
          aria-label="group selection"
          (click)="flipValue(group);clickDetected($event);"
        ></mat-checkbox>
        <div>{{group.name}}</div>
      </ng-container>
    </div>
  </div>
</div>

<div *ngIf="isLoading()" class="loader">
  <mat-spinner></mat-spinner>
  <p class="loader-msg">One moment...</p>
</div>
